import React, { useEffect, useState, useRef } from "react";
import SurveyContainer from "../atoms/layout/SurveyContainer";
import DisplayTimeBox from "../modules/application/DisplayTimeBox";
import useRecord from "../../api/hooks/recorder";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  deviceListState,
  isPracticeState,
  isRecordingState,
  isUploadingState,
  isVideoState,
  micState,
  selectedDeviceState,
  streamState,
} from "../../recoil/record";
import VolumeMeter from "../modules/record/VolumeMeter";
import useExamActions from "../../api/hooks/exam";
import ExamQuestionInfo from "../modules/exam/ExamQuestionInfo";
import { authState } from "recoil/auth";
import { applyStepState } from "../../recoil/pageStep";
import { ApplyStep } from "./ApplyRouter";
import Header from "../modules/layout/Header";
import useDidMountEffect from "../../api/hooks/effect";
import { MoonLoader } from "react-spinners";
import { speakLanguageToKorean } from "../../static";
import useApiActions from "../../recoil/api";
import useApplyActions from "../../api/hooks/apply";

const ONE_SECOND = 1000;

const Exam = () => {
  const videoRef = useRef(null);
  const record = useRecord();
  const stream = useRecoilValue(streamState);
  const examActions = useExamActions();
  const auth = useRecoilValue(authState);
  const [applyStep, setApplyStep] = useRecoilState(applyStepState);
  const [questionList, setQuestionList] = useState({});
  const [questionIndex, setQuestionIndex] = useState(1);
  const { setLog } = useApiActions();

  // 룸타입에 따라 타이틀이 달라짐
  // const room_type = auth?.data?.room_type;
  // const koreanTitle = speakLanguageToKorean(room_type);

  const isUploading = useRecoilValue(isUploadingState);
  //연습모드인지 아닌지
  const isPractice = useRecoilValue(isPracticeState);
  //녹화중
  const [isRecording, setIsRecording] = useRecoilState(isRecordingState);
  //준비시간
  const [prepareTime, setPrepareTime] = useState(15);
  //준비 완료시
  const [isReady, setIsReady] = useState(false);
  //답변시간
  const [answerTime, setAnswerTime] = useState(0);
  //시간 정보
  const [timeInfo, setTimeInfo] = useState({});
  //질문 종료시 스킵 가능
  const [isSkip, setIsSkip] = useState(false);
  //질문 목록 가져오기

   const selectedDevice =useRecoilValue(selectedDeviceState);
  const [videoCheck, setVideoCheck] = useRecoilState(isVideoState);
  const hasMicPermissions = useRecoilValue(micState);
  const deviceList = useRecoilValue(deviceListState);

  useEffect(() => {
    record.forceStopRecording(selectedDevice);
    getExamList({ questionIndex });
  }, [questionIndex]);

  useEffect(() => {
    if (hasMicPermissions?.state !== "granted") {
      alert("권한이 변경되었습니다.");
      setApplyStep(0);
      setLog({
        params: {
          text: "권한 변경으로 시험실 나감",
        },
      });
    }
  }, [hasMicPermissions, deviceList]);

  const getExamList = async ({ questionIndex }) => {
    if (isPractice) {
      const res = await examActions.getPracticeExamList();
      if (res.data) {
        setQuestionList(res.data);
        setQuestionIndex(1);
        handleRecording();
      }
    } else {
      const res = await examActions.getExamList({
        examNumber: questionIndex,
      });

      if (res?.status === 400 && res?.data.status === 453) {
        alert("모든 문항을 응시했습니다.");

        setApplyStep(applyStep + 1);
        // 여기에 완료 api 넣기
        // const endExamPromise = await examActions.endExamCallback({
        //   // 파라미터 머 필요할까
        // });
        
        // endExamPromise
        //   .then(response => {
        //     console.log(response);
        //   })
        //   .catch(err => {
        //     console.error(err)
        //   })
        //   .finally(() => {
        //     console.log("호출 끝")
        //   })
      }
      if (res.status === 200) {      
        setQuestionList(res.data);
        setQuestionIndex(res.data.tester_state);
        handleRecording();
      }
    }
  };

  //업로드가 완료되었을 때
  useDidMountEffect(() => {
    if (!isUploading) {
      setPrepareTime(timeInfo.ready_time_second);
      setAnswerTime(0);
      setIsReady(false);
      setIsSkip(false);
      if (isPractice) {
        setApplyStep(ApplyStep.PRACTICE_DONE);
        return;
      }
      if (questionIndex + 1 !== questionList.length) {
        setQuestionIndex((old) => old + 1);
      } else {
        setApplyStep(applyStep + 1);
      }
    }
  }, [isUploading]);

  useEffect(() => {
    if (questionList) {
      const { maxres_time_second, minres_time_second, ready_time_second } =
        questionList;
      setTimeInfo({
        maxres_time_second,
        minres_time_second,
        // minres_time_second: 5,
        ready_time_second,
      });
      setIsReady(true);

      setPrepareTime(ready_time_second);
    }
  }, [questionList, questionIndex]);

  useEffect(() => {
    
    const setStream = async () => {
      videoRef.current.srcObject = stream;
    };

    setStream();
  }, [stream]);

  const convertMss = (time) => {
    let mm = time % 60;
    if (mm < 10) {
      mm = `0${mm}`;
    }
    return `${parseInt(time / 60)}:${mm}`;
  };

  //녹화 시작
  const handleRecording = () => {
    setIsSkip(true);
    setIsReady(true);

    if (!isRecording) {
      record.handleRecording();
    }
  };

  //녹화 종료
  const stopRecording = async () => {
    const res = await record.stopRecording({
      examNumber: questionIndex,
      //video는 1 audio는 0
      media_type: videoCheck,
      //연습모드일 때
      isPractice,
    });

    setIsRecording(false);
  };

  //준비 시간 카운트 다운
  useEffect(() => {
    if (isReady && prepareTime === 0) {
      setIsRecording(true);
      setPrepareTime(0);
    }
    if (!isRecording && prepareTime > 0 && isReady) {
      const timer = setInterval(() => {
        setPrepareTime((old) => old - 1);
      }, ONE_SECOND);

      return () => clearInterval(timer);
    }
  }, [prepareTime, isReady]);

  //시험 시간 카운트 업
  useEffect(() => {
    if (answerTime === timeInfo.maxres_time_second && isRecording) {
      stopRecording();
    }
    if (isRecording && prepareTime === 0) {
      const timer =
        answerTime < timeInfo.maxres_time_second &&
        setInterval(() => {
          setAnswerTime((old) => old + 1);
        }, ONE_SECOND);
      return () => clearInterval(timer);
    }
  }, [prepareTime, answerTime, isRecording]);

  return (
    <div>
      {isUploading && (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#eee",
            opacity: 0.5,
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        >
          <MoonLoader color={"#000"} loading={isUploading} />
        </div>
      )}

      <Header />
      {/* <SurveyContainer title={koreanTitle}> */}
      <SurveyContainer title="영어 말하기 평가">
        {/* 업로드 실패했을때
        현재 문항을 재응시 (200말고 다른거) alert로 "현재번호" 업로드에 실패했습니다.
        "현재번호" 문항을 재응시합니다.  */}

        <div className="base-sec-sec exam-sec">
          <div className="page-title text-align-center">
            <p>{isPractice ? "연습평가" : "실전평가"}</p>
          </div>
          <div className="qna">
            <ExamQuestionInfo
              handleRecording={handleRecording}
              questionIndex={questionIndex}
              questionList={questionList}
            />

            <div className="half-area">
              <div className="black-box text-align-center">
                <p>답변</p>
              </div>
              <div>
                <DisplayTimeBox timeInfo={timeInfo} />
                <div className="now-step flex">
                  <div>
                    <p className="time-step-title">
                      {isRecording ? "답변시간" : "준비시간"}
                    </p>
                  </div>
                  <div className="text-align-center">
                    <p style={{ color: isRecording && "#e52828" }}>
                      {isRecording
                        ? `녹화중 ${convertMss(answerTime)}`
                        : convertMss(prepareTime)}
                    </p>
                    {isRecording ? (
                      <div className="slidecontainer time-gauge">
                        <input
                          disabled
                          type="range"
                          min={0}
                          max={timeInfo.maxres_time_second}
                          value={answerTime}
                          className="slider"
                        />
                      </div>
                    ) : (
                      <div className="slidecontainer time-gauge">
                        <input
                          disabled
                          type="range"
                          min={0}
                          max={timeInfo.ready_time_second}
                          value={prepareTime}
                          className="slider"
                        />
                      </div>
                    )}
                  </div>
                  <div>
                    {isRecording && (
                      <button
                        disabled={answerTime < timeInfo.minres_time_second}
                        className="start-step-btn"
                        onClick={() => stopRecording()}
                      >
                        답변종료
                      </button>
                    )}
                    {!isRecording && (
                      <button
                        disabled={!isSkip || isUploading}
                        className="start-step-btn"
                        onClick={() => {
                          setIsRecording(true);
                          setPrepareTime(0);
                        }}
                      >
                        답변시작
                      </button>
                    )}
                  </div>
                </div>
                <div className="camera-screen">
                  <video
                    muted
                    autoPlay
                    playsInline
                    ref={videoRef}
                    width="100%"
                    height="100%"
                  />
                </div>
                <VolumeMeter />
              </div>
            </div>
          </div>
          <div className="base-sec-bottom text-align-center">
            <p>답변이 끝나면 '답변완료' 를 선택하고, 다음 단계로 이동하세요.</p>
          </div>
        </div>
      </SurveyContainer>
    </div>
  );
};

export default Exam;
